<if-notification></if-notification>
<div class="header-wrapper">
    <div *ngIf="environment !== 'prod'" class="dev-banner">{{environment ? environment : 'unknown'}}</div>
    <dol-header-bar></dol-header-bar>
</div>
<router-outlet></router-outlet>
<dol-footer-bar></dol-footer-bar>
